import { DiscoveryRow, FeedbackReason } from "@radarly/models/discovery";
import {
  InsightPage,
  InsightPageRecurringSnapshot,
  InsightPageSnapshotFactory,
  RecurringSnapshotPayload,
} from "@radarly/models/insight-pages/model";
import { InsightPageRepo, Pagination } from "./InsightPageRepo";

export class PublicInsightPageRepo implements InsightPageRepo {
  page: InsightPage;
  constructor(page: InsightPage) {
    this.page = page;
  }
  public getInsightPages(projectId: number, workspaceId: number): never {
    throw new Error("not available");
  }

  public getLeanInsightPages(
    projectId: number,
    workspaceId: number,
    pagination: Pagination
  ): never {
    throw new Error("not available");
  }

  public getInsightPage(projectId: number, id: InsightPage["id"]) {
    return Promise.resolve(this.page);
  }
  setInsightPage(projectId: number, page: InsightPage): never {
    throw new Error("not available");
  }
  deleteInsightPage(projectId: number, id: InsightPage["id"]): never {
    throw new Error("not available");
  }

  sendSnapshot(
    projectId: number,
    id: InsightPage["id"],
    snapshot: InsightPageSnapshotFactory
  ): never {
    throw new Error("not available");
  }

  sendRecurringSnapshot(
    projectId: number,
    id: InsightPage["id"],
    snapshot: RecurringSnapshotPayload
  ): never {
    throw new Error("not available");
  }

  shareInsightPageAccess(
    projectId: number,
    id: InsightPage["id"],
    access: InsightPage["access"],
    sharedWith: InsightPage["sharedWith"]
  ): never {
    throw new Error("Implement shareInsightPageAccess");
  }
  public getRecurringSnapshots(
    projectId: number,
    id: InsightPage["id"]
  ): never {
    throw new Error("Implement getRecurringSnapshots");
  }

  batchUpdateRecurringSnapshots(
    projectId: number,
    id: InsightPage["id"],
    snapshots: Array<{
      id: InsightPageRecurringSnapshot["id"];
      page: InsightPage;
    }>
  ): never {
    throw new Error("Implement batchUpdateRecurringSnapshots");
  }

  public deleteRecurringSnapshot(
    projectId: number,
    pageId: InsightPage["id"],
    RecurringSnapshotId: InsightPageRecurringSnapshot["id"]
  ): never {
    throw new Error("Implement deleteRecurringSnapshot");
  }

  public getInvalidRecurringSnapshots(
    projectId: number,
    id: InsightPage["id"],
    timezone: InsightPage["timezone"]
  ): never {
    throw new Error("Implement getInvalidRecurringSnapshots");
  }

  public getDiscoveryPage(projectId: number, workspaceId: number): never {
    throw new Error("Implement getDiscoveryPage");
  }

  public getDiscoveryStatus(projectId: number, workspaceId: number): never {
    throw new Error("Implement getDiscoveryStatus");
  }

  public async getDiscoveryDetails(
    projectId: number,
    workspaceId: number,
    meta: DiscoveryRow["meta"]
  ): Promise<never> {
    throw new Error("Implement getDiscoveryPage");
  }

  public async sendDiscoveryFeedback(
    projectId: number,
    workspaceId: number,
    page: InsightPage,
    feedback: boolean,
    reason: FeedbackReason,
    message?: string
  ): Promise<never> {
    throw new Error("Implement sendDiscoveryFeedback");
  }

  public async searchPages(
    projectId: number,
    search: string,
    workspaceId: number,
    pagination: Pagination
  ): Promise<never> {
    throw new Error("Implement searchPages");
  }

  public saveDiscoverySnapshot(
    projectId: number,
    snapshot: InsightPage
  ): Promise<never> {
    throw new Error("not available");
  }
}
